import React, { Component } from 'react';

class CustomRadio extends Component {
    render() {
        const { number,label, option, name } = this.props;

        return (
            <div className="radio">
                <input id={number} name={name} type="radio" value={option} {...this.props.input} />
                <label htmlFor={number}>
                    {label}
                </label>
            </div>
        );
    }
}

export default CustomRadio;
